import { useConfig } from 'shared/config/ConfigContext';
import { formatISODate } from 'shared/util/datetime-fns';
import { queryString } from 'shared/util/query';
import useSWR from 'swr';
import { getJsonBody } from '@/api/apiHelpers';

type Availability = Record<string, number | boolean | Error> | null;
type DirectBookingPrice = Record<string, unknown> | null;
export type AvailabilityResponse = {
    availability: Availability;
    price: DirectBookingPrice;
};

export const useAvailabilityForImport = (adId: number, startDate: Date | null, endDate: Date | null) => {
    const { apiExternalUrl } = useConfig();
    const shouldFetch = !!startDate; // only fetch availability data when a date is selected
    const key = shouldFetch ? { adId, startDate: formatISODate(startDate), endDate: endDate ? formatISODate(endDate) : null } : null;

    const fetchAvailabilityForImport = (data) =>
        fetch(`${apiExternalUrl}/calendar/availabilityImport${queryString(data)}`).then(getJsonBody);

    const { data, error } = useSWR<AvailabilityResponse, Error>(key, fetchAvailabilityForImport, { revalidateOnFocus: false });

    return {
        availability: error ? { error } : data?.availability,
        price: data?.price,
        loading: shouldFetch && !data && !error,
    };
};
